export default __webpack_public_path__ + "static/media/f9b4bd30b3f003d3e80cf8e983889740.svg";